<template>
	<TheButton
		type="danger"
		@buttonclick="$emit('buttonclick')"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave"
		:onlyIcon="!showFullButton"
		class="button-sticky"
		:style="{ width: !showFullButton ? '45px' : width + 'px' }"
		:disabled="disabled"
	>
		<slot name="icon"></slot>
		<slot name="text" v-if="showFullButton"></slot>
	</TheButton>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import TheButton from '../TheButton.vue';

export default defineComponent({
	name: 'ButtonSticky',
	data() {
		return {
			scrollDirection: 'up',
			prevScrollTop: 0,
		};
	},
	props: {
		width: {
			type: Number,
			default: 120,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		TheButton,
	},
	emits: ['buttonclick'],
	setup(props, { emit }) {
		const isHovered = ref(false);

		const onMouseEnter = () => {
			isHovered.value = true;
		};

		const onMouseLeave = () => {
			isHovered.value = false;
		};

		return {
			isHovered,
			onMouseEnter,
			onMouseLeave,
		};
	},
	methods: {
		handleScroll() {
			const scrollTop = document.documentElement.scrollTop;

			if (scrollTop > this.prevScrollTop) {
				this.scrollDirection = 'down';
			} else {
				this.scrollDirection = 'up';
			}

			this.prevScrollTop = scrollTop;
		},
	},
	computed: {
		showFullButton() {
			if (window.innerWidth < 765) {
				return true; // always show full button on mobile
			}

			if (this.isHovered) {
				return true;
			}

			if (this.scrollDirection == 'up') {
				return true;
			}

			return false;
		},
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('scroll', this.handleScroll);
		});
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
});
</script>

<style lang="scss">
@use '../../scss/vars.scss' as *;

$size: 45px;
.button-sticky.is-round.el-button {
	position: fixed;
	top: 50%;
	right: 1rem;
	height: $size;
	width: 100px;
	font-size: 1rem;
	border-radius: 30px;
	transform: translateY(-50%);
	transition:
		width 0.3s ease,
		border-radius 0.3s ease;
	z-index: 1000000;

	.el-icon {
		font-size: 1.3rem;
		padding-right: 0.5rem;
	}

	&.button--onlyicon {
		height: $size;

		.el-icon {
			padding-right: 0;
		}
	}
}

// stick to bottom on mobile
@media screen and (max-width: $mobile_maxwidth) {
	.button-sticky.is-round.el-button {
		top: initial;
		bottom: 0;
		left: 0;
		right: 0;
		transform: translateY(0);
		width: 100% !important;
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
	}
}
</style>
